import React from 'react';
import Main from '../components/Members/Members';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

function Members() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default Members;
